export enum OppgaveType {
  Skjema = 1,
  Samtykke = 2,
  Ekstern = 3,
  Verktoy = 4,
  Informasjon = 5,
  Betaling = 6,
}
